module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    directives: [{
      name: "pull",
      rawName: "v-pull",
      value: (_vm.refresh),
      expression: "refresh"
    }]
  }, [_c('section', {
    staticClass: "field-box"
  }, [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊序号")]), _vm._v(" "), _c('dd', {
    staticClass: "f-strong"
  }, [_vm._v(_vm._s(_vm._f("formatNum")(_vm.visitInfoDetail.index)))])])]), _vm._v(" "), _c('section', {
    staticClass: "field-box"
  }, [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊时间")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.visitInfoDetail.treatDate)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊医院")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.visitInfoDetail.hospital))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊类型")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.visitInfoDetail.treatType))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊科室")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.visitInfoDetail.deptName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("主治医生")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.visitInfoDetail.doctName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("主诉")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.visitInfoDetail.chiefComplaint))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("诊断名称")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.visitInfoDetail.treatName))])])]), _vm._v(" "), _vm._l((_vm.medInfo.drugItems), function(drugItem, index) {
    return _c('div', [_c('section', {
      staticClass: "thick"
    }, [_c('div', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.showDetail(drugItem)
        }
      }
    }, [_c('span', {
      staticClass: "f-strong"
    }, [_vm._v("药品序号 " + _vm._s(_vm._f("formatNum")((index + 1))))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "float": "right",
        "padding-right": "1rem"
      }
    }, [(drugItem.showDetailInfo) ? _c('span', {
      staticClass: "arr-gray-down"
    }) : _vm._e(), _vm._v(" "), (!drugItem.showDetailInfo) ? _c('span', {
      staticClass: "arr-gray-up"
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!drugItem.showDetailInfo),
        expression: "!drugItem.showDetailInfo"
      }]
    }, [_c('div', {
      staticClass: "report-detail"
    }, [_c('div', {
      staticClass: "field",
      staticStyle: {
        "background": "#f8f8f8"
      }
    }, [_c('div', [_c('label', [_vm._v(_vm._s(drugItem.drugName))]), _vm._v(" "), _c('label', {
      staticClass: "f-minor"
    }, [_vm._v("（" + _vm._s(drugItem.frequency) + "）")])])]), _vm._v(" "), _c('div', {
      staticClass: "report-table-container"
    }, [_c('table', {
      staticClass: "report-table"
    }, [_c('tr', [_c('td', {
      staticClass: "f-minor"
    }, [_vm._v("发药量")]), _vm._v(" "), _c('td', {
      staticClass: "f-minor"
    }, [_vm._v("用药量")]), _vm._v(" "), _c('td', {
      staticClass: "f-minor"
    }, [_vm._v("用药频次")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(drugItem.grantDose))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(drugItem.dosage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(drugItem.frequency))])])])])])])])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daadafbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/healthRecord/VisitRecordDetail.vue
// module id = 878
// module chunks = 0